import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Button from '../../common/Button';

function MobileSelector({ buttons, onConfirm, importImage }) {
  const [choosen, setChoosen] = useState(buttons[0]);
  const [image, setImage] = useState(null);
  useEffect(() => {
    // That's an annoying hack because I'm no Functional Developer.
    // In fact, I might not be a JS Deveveloper as well.
    document.getElementsByName(buttons[0].label)[0].click();
  }, [buttons]);

  const showContent = (event) => {
    event.preventDefault();
    const { target } = event;
    const choosenOne = buttons.find(x => x.label === target.name);
    setChoosen(choosenOne);
    if (choosenOne.image) {
      setImage(importImage(choosenOne.image));
    } else {
      setImage(null);
    }
  };

  const handleConfirmClick = (event) => {
    event.preventDefault();
    onConfirm(choosen);
  };

  const { t } = useTranslation();

  return (
    <>
      <div className="container d-flex flex-column align-content-between mobile-selector mb-5 mb-md-2">
        <div className="mb-auto">
          {choosen.title && <p>{choosen.title}</p>}
          <div>
            {choosen.description && <p>{choosen.description}</p>}
            {image && <img className="img-fluid " src={image} alt="selector" /> }
          </div>
        </div>
        <div className="d-flex mt-2 mb-3 flex-grow-1 justify-content-center flex-wrap buttons">
          {buttons.map(x => (
            <Button
              key={x.label}
              name={x.label}
              label={x.label}
              onClick={showContent}
              cssClass={choosen.label === x.label
                ? 'btn btn-circle btn-circle-selected'
                : 'btn btn-circle'}
            />
          ))}
        </div>
      </div>
      <Button
        name="Confirm"
        label={t('common.confirm')}
        onClick={handleConfirmClick}
        cssClass="btn btn-block fixed-bottom"
      />
    </>
  );
}

MobileSelector.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.any).isRequired,
  onConfirm: PropTypes.func.isRequired,
  importImage: PropTypes.func.isRequired,
};

MobileSelector.defaultProps = {};

export default MobileSelector;
